/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plant_Tree_For_EarthInputs */

const en_plant_tree_for_earth = /** @type {(inputs: Plant_Tree_For_EarthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plant real trees`)
};

const ar_plant_tree_for_earth = /** @type {(inputs: Plant_Tree_For_EarthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ازرع أشجارًا حقيقية`)
};

const de_plant_tree_for_earth = /** @type {(inputs: Plant_Tree_For_EarthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Echte Bäume pflanzen`)
};

const es_plant_tree_for_earth = /** @type {(inputs: Plant_Tree_For_EarthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planta árboles reales`)
};

const fr_plant_tree_for_earth = /** @type {(inputs: Plant_Tree_For_EarthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plantez de véritables arbres`)
};

const it_plant_tree_for_earth = /** @type {(inputs: Plant_Tree_For_EarthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pianta alberi veri`)
};

const ja_plant_tree_for_earth = /** @type {(inputs: Plant_Tree_For_EarthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本物の木を植える`)
};

const ko_plant_tree_for_earth = /** @type {(inputs: Plant_Tree_For_EarthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`실제 나무 기부하기`)
};

const pt_br_plant_tree_for_earth = /** @type {(inputs: Plant_Tree_For_EarthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plante árvores reais`)
};

const ru_plant_tree_for_earth = /** @type {(inputs: Plant_Tree_For_EarthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сажайте настоящие деревья`)
};

const th_plant_tree_for_earth = /** @type {(inputs: Plant_Tree_For_EarthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปลูกต้นไม้จริง`)
};

const tr_plant_tree_for_earth = /** @type {(inputs: Plant_Tree_For_EarthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerçek ağaçlar dik`)
};

const zh_cn_plant_tree_for_earth = /** @type {(inputs: Plant_Tree_For_EarthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为地球种下真树`)
};

const zh_tw_plant_tree_for_earth = /** @type {(inputs: Plant_Tree_For_EarthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`為地球種下真樹`)
};

/**
* | output |
* | --- |
* | "Plant real trees" |
*
* @param {Plant_Tree_For_EarthInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const plant_tree_for_earth = /** @type {((inputs?: Plant_Tree_For_EarthInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plant_Tree_For_EarthInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_plant_tree_for_earth(inputs)
	if (locale === "ar") return ar_plant_tree_for_earth(inputs)
	if (locale === "de") return de_plant_tree_for_earth(inputs)
	if (locale === "es") return es_plant_tree_for_earth(inputs)
	if (locale === "fr") return fr_plant_tree_for_earth(inputs)
	if (locale === "it") return it_plant_tree_for_earth(inputs)
	if (locale === "ja") return ja_plant_tree_for_earth(inputs)
	if (locale === "ko") return ko_plant_tree_for_earth(inputs)
	if (locale === "pt_br") return pt_br_plant_tree_for_earth(inputs)
	if (locale === "ru") return ru_plant_tree_for_earth(inputs)
	if (locale === "th") return th_plant_tree_for_earth(inputs)
	if (locale === "tr") return tr_plant_tree_for_earth(inputs)
	if (locale === "zh_cn") return zh_cn_plant_tree_for_earth(inputs)
	return zh_tw_plant_tree_for_earth(inputs)
});